export default __webpack_public_path__ + "static/media/addShortcut-2-en.51de03b8.jpg";